

export class DocumentTypeOutputWithoutStatus implements IDocumentTypeOutputWithoutStatus {
    /** The auto-generated id of the document type master */
    document_type_id!: number;
    /** The  document type name with 255 character limit */
    document_type_name!: string;

    constructor(data?: IDocumentTypeOutputWithoutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.document_type_id = _data["document_type_id"];
            this.document_type_name = _data["document_type_name"];
        }
    }

    static fromJS(data: any): DocumentTypeOutputWithoutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeOutputWithoutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["document_type_id"] = this.document_type_id;
        data["document_type_name"] = this.document_type_name;
        return data; 
    }
}

export interface IDocumentTypeOutputWithoutStatus {
    /** The auto-generated id of the document type master */
    document_type_id: number;
    /** The  document type name with 255 character limit */
    document_type_name: string;
}

